var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZirbanaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.75,
    height: 12.75,
    viewBox: "0 0 12.75 12.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "software_vector_box",
    transform: "translate(-0.625 -0.625)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4068",
    "data-name": "Rectangle 4068",
    width: 2,
    height: 2,
    transform: "translate(1 11)",
    fill: "none",
    stroke: "#29a19c",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4069",
    "data-name": "Rectangle 4069",
    width: 2,
    height: 2,
    transform: "translate(11 11)",
    fill: "none",
    stroke: "#29a19c",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4070",
    "data-name": "Rectangle 4070",
    width: 2,
    height: 2,
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#29a19c",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4071",
    "data-name": "Rectangle 4071",
    width: 2,
    height: 2,
    transform: "translate(11 1)",
    fill: "none",
    stroke: "#29a19c",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3613",
    "data-name": "Line 3613",
    y2: 8,
    transform: "translate(2 3)",
    fill: "none",
    stroke: "#29a19c",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3614",
    "data-name": "Line 3614",
    y2: 8,
    transform: "translate(12 3)",
    fill: "none",
    stroke: "#29a19c",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3615",
    "data-name": "Line 3615",
    x1: 8,
    transform: "translate(3 2)",
    fill: "none",
    stroke: "#29a19c",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3616",
    "data-name": "Line 3616",
    x1: 8,
    transform: "translate(3 12)",
    fill: "none",
    stroke: "#29a19c",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZirbanaIcon);
export default __webpack_public_path__ + "static/media/ZirbanaIcon.092e8e908f3f9566ab4757309ac7d386.svg";
export { ForwardRef as ReactComponent };